import React from 'react';

import pdfIcon from 'assets/images/jpg/pdf-icon.jpg';
import useExportManuel from 'hooks/referentiels/useExportManuel';

import FileCard from '../../FileCard/FileCard';

import { UserManual } from './types';

interface UserManualCardsProps {
  manuals: UserManual[];
}

function UserManualCards({
  manuals,
}: UserManualCardsProps): React.ReactElement {
  return (
    <>
      <h1>Manuel utilisateur</h1>
      <>
        {manuals.length === 0 && (
          <div className="noAvailableContent">
            {`Aucun contenu n'est disponible.`}
          </div>
        )}
        {manuals.map((manual, i) => (
          <UserManualCard key={i} manual={manual} />
        ))}
      </>
    </>
  );
}

interface UserManualCardProps {
  manual: UserManual;
}

function UserManualCard({
  manual: { title, description, type, manuelType },
}: UserManualCardProps): React.ReactElement {
  const { download } = useExportManuel(type, manuelType);
  return (
    <FileCard
      download={download}
      icon={pdfIcon}
      title={title}
      description={description}
    />
  );
}

export default UserManualCards;
